// extracted by mini-css-extract-plugin
export var barContainer = "_2l-0";
export var extraThin = "_2l-3";
export var fillBar = "_2l-6";
export var fillContainer = "_2l-4";
export var overflow = "_2l-8";
export var overflowContainer = "_2l-5";
export var regular = "_2l-7";
export var thick = "_2l-1";
export var thin = "_2l-2";